import React from "react";
import { TableCellProps } from "../../tables/components/TableCell";
import { WingmanAdminDocument } from "../models/WingmanAdminDocument";
import { UploadStatus } from "../../locations/features/migrations/enums/MigrationStatus";
import { UploadStatusIcon } from "../../locations/features/migrations/components/MigrationRowStatusIcon";

const WingmanAdminUploadStatusCell = ({
  row,
}: TableCellProps<WingmanAdminDocument, string | undefined>) => {
  const model = row.original as WingmanAdminDocument;

  return (
    <div className="flex gap-4 justify-center min-w-8">
      <UploadStatusIcon status={model.uploadStatus ?? UploadStatus.Complete} />
    </div>
  );
};

export default WingmanAdminUploadStatusCell;
